<template>
  	<WithdrawList />
</template>

<script>

// @ is an alias to /src
import WithdrawList from "@/components/WithdrawList.vue";

export default {
  name: "WithdrawLists",
  components: {
    WithdrawList,
  },
};
</script>
